<!--


CONTAS A RECEBER
grid:
- fin.aberto = habilita botao baixar (handleBaixar)
- fin.vencido = botao emitir carta de cobrança
- fin.baixado = botao emitir recibo
- fin.baixado = linha em cinza claro
- fin.perdido = linha amarela clara
- no filtro "vencidos" habilitar o envio da carta de cobrança por email
  - listar os clientes e total de títulos atrasados em modal, marcar os clientes e enviar email
  - /fin/cartadecobranca (POST)
  - desenvolver layout html para o modelo da carta de cobrança

CONTAS A PAGAR
grid:
- fin.baixado = botao emitir recibo
- fin.baixado = linha em cinza claro
- contas a pagar nao tem o status "perdido"

CAIXA E BANCOS
- habilitar filtro de contas (conforme contas-fluxo-caixa.vue)
- habilitar filtro de cliente/fornecedor
- habilitar filtro de documento
- habilitar filtro de valor
- exibir div de totais
- nao exibir filtro de totais


-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import FinanceiroForm from './financeiro-form'
import FinanceiroMovimentoForm from './financeiro-movimento-form'
import FinanceiroTransfForm from './financeiro-transf-form'
import { apiORDS, apiDownload, apiDownloadPDF, urlORDS, apiDownload2 } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'
import { apiORDSpost } from '../shared/api-functions'
import { SysVars } from '../main';
import Button from '../components/button.vue'
import FinanceiroPrintRecibo from '../forms/financeiro-print-recibo.vue'
import FinanceiroRelatorioAgrupado from '../forms/financeiro-relatorio-agrupado.vue'
import FinanceiroRelatorioData from '../forms/financeiro-relatorio-data.vue'
import FinanceiroRelatorioExtrato from '../forms/financeiro-relatorio-extrato.vue'

export default {
    data() {
        return {
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            moreActionsBarList: [],
            monthFilter: {},
            statusQuery: '',
            filterList: [],
            paramFilterList: {},
            showForm: false,
            showTransfForm: false,
            showMovForm: false,
            codfin: '',
            tipofin: null,
            url: '',
            urlboleto: 'fin/boleto/',
            textQuery: '',

            listContas: null,
            contas: null,
            listTipos: [ { id: 1, text: 'Abertas' }, { id: 2, text: 'Vencidas' }, { id: 3, text: 'Baixadas' }, { id: 4, text: 'Perdidas' },  ],
            tipos: ['1','2','3','4'],

            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }],
            },
            periodo: { startDate: null, endDate: null },
            periodoEmissao: { startDate: null, endDate: null },
            periodoVencimento: { startDate: null, endDate: null },
            periodoRecebimento: { startDate: null, endDate: null },
            documento: { value: null },
            valor: { start: null, end: null },
            codpart: null,
            codcta: null,
            activeTab: 0,

            showAlert: false,

            dados: null,
            filial: null,

            tabs: [
                { title: 'Contas a Receber', icon: 'fa-archive' },
                { title: 'Contas a Pagar', icon: 'fa-cubes' },
                { title: 'Caixa e Bancos', icon: 'fa-cubes' }
            ],

            tipoRelatorio: null,
            tipoOptions: [{ id: 1, text: "Recibo" }, { id: 2, text: "Relatório" }, { id: 3, text: "Relatório (Data)" }],
            finListGroup: {},
            showModalCobranca: false,
            titulosVencidosPorCliente: [],
            allFinListChecked: false,
            cartaCobrancaCheckAll: false,

            showRelatorio: false,
            showRelatorioData: false,
            showRelatorioExtrato: false,
            showRecibo: false,
            showModalErrosBoleto: false,
            listErrosBoleto: [],
            showModalEnviarEmailBoleto: false,
            selectedTitulosBoleto: [],

            tipo: null,
            listFiltros: [
              { id: '1', text: 'A Vencer'},
              { id: '2', text: 'Vencidos'},
              { id: '5', text: 'Todos Vencidos'},
              { id: '3', text: 'Baixados'},
              { id: '4', text: 'Cancelados/Perdidos'},
              { id: '6', text: 'Todos Por Data Emissão'},
              { id: '7', text: 'Abertos Por Data Alteração'},
              { id: '9', text: 'Todos Por Data Alteração'},
            ],
            sortKey: '',
            sortOrder: 1,

        }

    },

    computed: {
        companyName: function () {
            return this.$store.getters.getFilial.fantasia
        },
        maisAcoes: function () {
            let acoes = []
            if (this.receberTab) {
                acoes.push({ label: 'Relatório Agrupado Por Data', action: '3' })
                acoes.push({ label: 'Relatório Agrupado Por Cliente', action: '2' })
            }
            if (this.pagarTab) {
                acoes.push({ label: 'Relatório Agrupado Por Data', action: '3' })
                acoes.push({ label: 'Relatório Agrupado Por Fornecedor', action: '2' })
            }
            if (this.extratoTab) {
                acoes.push({ label: 'Incluir Transferência', action: '1' })
                acoes.push({ label: 'Relatório Extrato', action: '4' })
            }
            acoes.push({ label: 'Configurar Natureza Financeira', action: '20' })
            acoes.push({ label: 'Configurar Contas e Bancos', action: '30' })
            acoes.push({ label: 'Exportar Excel', action: '50' })

            return acoes
        },

        receberTab: function () {
            return this.activeTab == 0
        },

        pagarTab: function () {
            return this.activeTab == 1
        },

        extratoTab: function () {
            return this.activeTab == 2
        },

        finList: function () {
            let finList = []

            if (this.dados && this.dados.dados){
                this.dados.dados
                  .forEach((fin, i)=>{
                    if (this.dados.dados[i].isChecked === undefined) {
                        this.$set(this.dados.dados[i], 'isChecked', false);
                    }
                  })

                finList = [...this.dados.dados]

                if (this.sortKey) {
                    const key = this.sortKey;
                    const order = this.sortOrder;

                    finList.sort((a, b) => {
                        let valA = a[key];
                        let valB = b[key];

                        // Comparação de datas
                        if (key === 'dtemissao' || key === 'vencimento' || key === 'data' || key === 'dataAlteracao' || key === 'dataBaixa') {
                            const dateA = valA ? new Date(valA) : new Date(0);
                            const dateB = valB ? new Date(valB) : new Date(0);
                            return (dateA - dateB) * order;
                        }

                        // Comparação de valores numéricos
                        if (key === 'vlr' || key === 'saldo') {
                            const numA = parseFloat(valA) || 0;
                            const numB = parseFloat(valB) || 0;
                            return (numA - numB) * order;
                        }

                        // Comparação de strings
                        const strA = valA ? String(valA).toLowerCase() : '';
                        const strB = valB ? String(valB).toLowerCase() : '';
                        return strA.localeCompare(strB, 'pt-BR') * order;
                    });
                }
                this.showAlert = true
            }

            return finList
        },

        printFinList() {
            const finList = this.finList
            if (finList) {
                return finList.filter((obj) => {
                    return obj.isChecked === true
                })
            }
        },

        finListGrupo() {
            const finList = this.finList

            const fornecedores = finList.map((fin) => {
                return { codpart: fin.codpart, nome: fin.nome }
            });

            const fornecedoresSemRepeticao = fornecedores.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null))

            let finListGrupo = []
            let totalGeral = []

            fornecedoresSemRepeticao.map((fornecedores) => {
                let total = 0

                finListGrupo.push(fornecedores)

                finList.filter((obj) => {
                    if (obj.codpart === fornecedores.codpart) {
                        finListGrupo.push(obj)
                        total = total + obj.vlr
                    }
                })

                totalGeral.push(total)
                total = { total: total }
                finListGrupo.push(total)
            })

            totalGeral = totalGeral.reduce((total, totalGeral) => total + totalGeral, 0)
            totalGeral = { totalGeral: totalGeral }
            finListGrupo.push(totalGeral)

            return finListGrupo
        },

        finListGrupoData() {
            const finList = this.finList

            const datas = finList.map((fin) => {
                return { data: fin.data }
            });

            const datasSemRepeticao = datas.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null))

            let finListGrupoData = []
            let totalGeral = []

            datasSemRepeticao.map((datas) => {
                let total = 0

                finListGrupoData.push(datas)

                finList.filter((obj) => {
                    if (obj.data === datas.data) {
                        finListGrupoData.push(obj)
                        total = total + obj.vlr
                    }
                })

                totalGeral.push(total)
                total = { total: total }
                finListGrupoData.push(total)
            })

            totalGeral = totalGeral.reduce((total, totalGeral) => total + totalGeral, 0)
            totalGeral = { totalGeral: totalGeral }
            finListGrupoData.push(totalGeral)

            return finListGrupoData
        }
    },

    watch: {
        tipos: function () {
            this.loadData()
        },

        tipo: function () {
            this.loadData()
        },

        contas: function () {
            this.loadData()
        },

        periodo: {
            handler() {
                this.loadData()
            },
            deep: true
        },

        cartaCobrancaCheckAll() {
            if (this.cartaCobrancaCheckAll) {
                this.titulosVencidosPorCliente.forEach(e => {
                    e.isChecked = true
                })
            } else {
                this.titulosVencidosPorCliente.forEach(e => {
                    e.isChecked = false
                })
            }
        }

    },

    methods: {
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 1 ? -1 : 1;
            } else {
                this.sortKey = key;
                this.sortOrder = 1;
            }
        },

        getSortIcon(key) {
            if (this.sortKey !== key) {
                return 'fa-sort text-muted-light';
            }
            return this.sortOrder === 1 ? 'fa-chevron-up text-primary' : 'fa-chevron-down text-primary';
        },

        closeModalErros () {
            this.showModalErrosBoleto = false
        },

        handleLimparFiltros (isLoadData) {
            this.codpart = null
            this.codcta = null
            this.documento.value = null
            this.valor.start = null
            this.valor.end = null
            if (!isLoadData)
                this.loadData()
        },

        textST (fin) {
            if (fin.perdido)
                return 'Perdido'
            else
            if (fin.cancelado)
                return 'Cancelado'
            else
            if (fin.baixado && fin.parcial)
                return 'Baixado Parcial'
            else
            if (fin.baixado)
                return 'Baixado'
        },

        handleVerifyToCheckAll(){
            this.allFinListChecked = !this.allFinListChecked
            this.finList.forEach( (fin) => {
                fin.isChecked = this.allFinListChecked
            })
        },

        dataStr(data) {
            if (!data)
              return ''
            else
              return formatDate(data)
        },

        datasTitulo (fin) {
            if (fin.tipo == 'R' || fin.tipo == 'P') {
                let str = 'Emissão: ' + this.dataStr(fin.dtemissao) + '\n Vencimento: ' + this.dataStr(fin.vencimento) + '\n Alteração: ' + this.dataStr(fin.dataAlteracao)

                if (fin.dataBaixa)
                    str = str + '\n Baixa: ' + this.dataStr(fin.dataBaixa)

                return str
            }

            return null
        },

        getClienteLabel (fin) {
            let label = fin.nome || ''
            if (fin.descricao) label += ' ' + fin.descricao
            if (fin.npedido) label += ' Pedido ' + fin.npedido
            if (fin.texto) label += ' ' + fin.texto
            return label.trim()
        },

        changeTab (idx) {
            //mudança de pagina
            this.activeTab = idx
            this.loadData()
        },

        handleEmiteBoleto(fin) {
            //EMISSAO DO BOLETO DO TITULO SELECIONADO
            let sendData = { titulos: [
                    {codfin: fin.codfin }
                    ] }
            apiDownloadPDF(this, this.urlboleto, sendData, 'post')
        },

        handleEdit (fin) {
            //abre a tela de edicao
            this.$modalForm(true)

            if (fin.aberto)
              this.crud = SysVars.crudU
            else
              this.crud = SysVars.crudView

            this.codfin = fin.codfin

            if (fin.tipo == 'R' || fin.tipo == 'P') {
              this.tipofin = fin.tipo
              this.showForm = true
            }
            else
            if (fin.tipo == 'E' || fin.tipo == 'S')
              this.showMovForm = true

            if (fin.stremessacnab == 1 || fin.stremessacnab == 2) {
              this.$erpToastError('Este título está em remessa e não pode ser alterado')
            }
        },

        handleNew (action) {
            //inclusao de registro

            if (!action) {
                this.crud = SysVars.crudI
                    this.codfin = ''
                if (this.receberTab)
                    this.tipofin = 'R'
                else
                if (this.pagarTab)
                    this.tipofin = 'P'

                this.$modalForm(true)
                if (!this.extratoTab)
                    this.showForm = true
                else
                    this.showMovForm = true
            }
            else
            if (action == '1') {
              this.crud = SysVars.crudI
              this.$modalForm(true)
              this.showTransfForm = true
            }
            else
            if (action == '20')
              this.handleNatureza()
            else
            if (action == '30')
              this.handleContas()
            else
            if (action == '40')
              this.handleCobranca()
            else
            if (action == '4') //extrato
              this.handlePrint(4)
            else
            if (action == '2') //relatorio por fornecedor/cliente
              this.handlePrint(2)
            else
            if (action == '3') //relatorio data
              this.handlePrint(3)
            else
            if (action == '50') //exportar excel
              this.loadData(true)
        },

        async handleBaixar(codfin) {
            //EFETUA A BAIXA DO TITULO
            var sendData = { titulos: [ { codfin: codfin } ] }
            const data = await apiORDSpost(this.$store, 'fin/baixar/', sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError(data.errmessages[0])
            } else {
              this.$erpToastSuccess('Baixa efetivada com sucesso.');
              this.loadData();
            }
        },

        async handleEstornarBaixa(codfin) {
            //DESFAZ A BAIXA DO TITULO
            var sendData = { titulos: [ { codfin: codfin } ] }
            const data = await apiORDSpost(this.$store, 'fin/estornarbaixa/', sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError(data.errmessages[0])
            } else {
              this.$erpToastSuccess('A baixa foi estornada.');
              this.loadData();
            }
        },

        handleNatureza () {
            this.$router.push('/natfinlist')
        },

        handleContas () {
            this.$router.push('/cta')
        },

        handleCobranca() {
            let clientes = this.finList.map((cliente) => {
                return { codpart: cliente.codpart, nome: cliente.nome, email: '' }
            })

            const clientesSemRepeticao = clientes.filter(function (item) {
                return !this[JSON.stringify(item)] && (this[JSON.stringify(item)] = true);
            }, Object.create(null))


            clientesSemRepeticao.map(async (cliente) => {
                await this.$store.dispatch('loadPart', { id: cliente.codpart } )

                const dadosCliente = this.$store.getters.getPart.length ? { ...this.$store.getters.getPart[0] } : {}

                if (!dadosCliente.emailcobranca && dadosCliente.partcontato.length) {
                    cliente.email = dadosCliente.partcontato[0].email
                } else {
                    cliente.email = dadosCliente.emailcobranca
                }

                let total = 0

                this.finList.filter((el) => {
                    if (el.codpart === cliente.codpart && el.vencido) {
                        total = total + el.vlr
                    }
                })

                cliente.total = total

                if (cliente.total) {
                    this.titulosVencidosPorCliente.push(cliente)
                }
            })

            this.showModalCobranca = true
        },

        async handleEnviarEmail() {
            const data = this.finList.filter(obj => {
                return obj.isChecked === true
            })

            if (!data.length) {
                return this.$erpToastError('Selecione ao menos 1 título antes de enviar o boleto')
            }

            this.selectedTitulosBoleto = data.map((fin) => {
                return {
                    codfin: fin.codfin,
                    doc: fin.doc,
                    parcela: fin.parcela,
                    codpart: fin.codpart,
                    nome: fin.nome,
                    vlr: fin.vlr,
                    email: ''
                }
            })

            // Carregar e-mails dos clientes sequencialmente para evitar condições de corrida no store global
            const uniqueCodparts = [...new Set(this.selectedTitulosBoleto.map(t => t.codpart))]

            for (const codpart of uniqueCodparts) {
                await this.$store.dispatch('loadPart', { id: codpart })
                const dadosCliente = this.$store.getters.getPart.length ? { ...this.$store.getters.getPart[0] } : {}
                let email = ''
                if (!dadosCliente.emailcobranca && dadosCliente.partcontato && dadosCliente.partcontato.length) {
                    email = dadosCliente.partcontato[0].email
                } else {
                    email = dadosCliente.emailcobranca || ''
                }

                this.selectedTitulosBoleto.forEach(titulo => {
                    if (titulo.codpart === codpart) {
                        titulo.email = email
                    }
                })
            }

            this.showModalEnviarEmailBoleto = true
        },

        closeModalEnviarEmailBoleto() {
            this.showModalEnviarEmailBoleto = false
            this.selectedTitulosBoleto = []
        },

        handleConfirmarEnviarEmailBoleto() {
            const noEmail = this.selectedTitulosBoleto.some(e => !e.email || !e.email.trim())

            if (noEmail) {
                return this.$erpToastError('Todos os boletos selecionados devem ter o campo e-mail preenchido')
            }

            let titulos_array = this.selectedTitulosBoleto.map((titulo) => {
                return { codfin: titulo.codfin, email: titulo.email }
            })

            let postData = { titulos: titulos_array }
            let URL = 'cnab/ar/boleto/'

            let self = this

            apiORDSpost(this.$store, URL, postData, 'post')
                .then(function (data) {
                    if (data.errosValidacao && data.errosValidacao.length) {
                        console.log('Erros validação: ', data.errosValidacao)
                        self.listErrosBoleto = data.errosValidacao
                        self.showModalErrosBoleto = true
                    } else {
                        self.$erpToastSuccess('E-mails colocados na fila para o envio!')
                    }
                    self.closeModalEnviarEmailBoleto()
                }, function() {
                    self.$erpToastError('Falha ao colocar E-mails na fila para o envio!')
                    self.closeModalEnviarEmailBoleto()
                });
        },

        closeModalCobranca() {
            this.showModalCobranca = false
        },

        handleEnviarCobranca() {
            const clientes = this.titulosVencidosPorCliente.filter(obj => {
                return obj.isChecked === true
            })

            const noEmail = clientes.some(e => e.email === null)

            if (noEmail) {
                return this.$erpToastError('Todos os itens selecionados devem ter o campo e-mail preenchido')
            }

            const periodos = [
                {
                    data_inicio: this.periodo.startDate,
                    data_termino: this.periodo.endDate
                }
            ]

            let postData = { clientes, periodos }
            let URL = 'fin/carta/'

            apiORDSpost(this.$store, URL, postData, 'post')

            this.$erpToastSuccess('Cobrança enviada com sucesso!')

            this.showModalCobranca = false
        },
        async handlePrint(tipoRelatorio) {

            if (tipoRelatorio == 1) {
                if (!this.printFinList.length) {
                    this.$erpToastError('Selecione ao menos 1 documento para impressão')
                    return
                }

                const naoBaixado = this.printFinList.find(fin => !fin.baixado)
                if (naoBaixado) {
                    this.$erpToastError('Somente títulos baixados podem emitir recibo.')
                    return
                }

                this.showRecibo = true
            }

            if (tipoRelatorio == 2) {
                this.showRelatorio = true
            }

            if (tipoRelatorio == 3) {
                this.showRelatorioData = true
            }

            if (tipoRelatorio == 4) {
                this.showRelatorioExtrato = true

            }


        },

        handleClosePrint() {
            this.showRelatorio = false
            this.showRelatorioData = false
            this.showRelatorioExtrato = false
            this.showRecibo = false
        },

        extensoMoeda(val) {
            var extenso = require('extenso')
            const value = val.toFixed(2).replace('.',',')
            const valor = extenso(value, { mode: 'currency', currency: { type: 'BRL' } })
            return valor
        },

        dataSemiExtenso(date) {
            const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]
            let data = new Date(date);
            let dataFormatada = ((data.getDate() + " " + meses[(data.getMonth())] + " " + data.getFullYear()))
            return dataFormatada
        },

        closeForm() {
            this.showForm = false
            this.showMovForm = false
            this.showTransfForm = false
            this.$modalForm(false)
            this.loadData();
        },

        // handleActionBarList (act) {
        //     // if (act == 2) {
        //     //     //exportar a lista de notas para planilha
        //     //     const data = this.nfList.map(nf => ({
        //     //         data: this.data(nf.data),
        //     //         serie: nf.serie,
        //     //         numeronf: nf.nf,
        //     //         operacao: this.operacaoNf(nf.operacaonf),
        //     //         natureza: nf.descricao,
        //     //         nome: nf.nome,
        //     //         total: formatValue(nf.totger,2)
        //     //     }))
        //     //     const csv = objectToCsv(data)
        //     //     downloadCsvReport(csv)
        //     // }

        // },

        // handleSearch(value) {
        //     //efetua a pesquisa
        //     let str = value.toUpperCase()
        //     this.statusQuery = 'text=' + str
        //     // this.filter = ''
        //     // if (value) {
        //     //     this.filter = '{"$or":[{"part_nome":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}},{"doc":{"$eq":"' + value + '"}}]}'
        //     // }
        //     this.loadData()
        // },

        // handleAdvancedFilter (filter, startDate, endDate) {
        //     //aplicação do filtro avancado
        //     this.monthQuery = 'after=' + startDate + '&before=' + endDate
        //     this.textQuery = ''
        //     this.loadData()
        // },

        handleFilterList (status) {
            //CLICK DO FILTER LIST
            this.loadData()
        },

        loadData (excel) {
            let param = {}
            param.query = ''

            this.filtro.periodos = [ { data_inicio: this.periodo.startDate, data_termino: this.periodo.endDate } ]
            this.filtro.vencimento = [ { data_inicio: this.periodoVencimento.startDate, data_termino: this.periodoVencimento.endDate } ]
            this.filtro.recebimento = [ { data_inicio: this.periodoRecebimento.startDate, data_termino: this.periodoRecebimento.endDate } ]
            this.filtro.emissao = [ { data_inicio: this.periodoEmissao.startDate, data_termino: this.periodoEmissao.endDate } ]
            this.filtro.excel = excel;
            this.filtro.contas = []

            // this.filtro.emitidosperiodo = (this.tipos.indexOf('6') >= 0)
            // if (!this.filtro.emitidosperiodo) {
            //     this.filtro.aberto = (this.tipos.indexOf('1') >= 0)
            //     this.filtro.vencido = (this.tipos.indexOf('2') >= 0)
            //     this.filtro.baixado = (this.tipos.indexOf('3') >= 0)
            //     this.filtro.perdido = (this.tipos.indexOf('4') >= 0)
            //     this.filtro.todosvencidos = (this.tipos.indexOf('5') >= 0)
            // }

            this.filtro.aberto = this.tipo == '1'
            this.filtro.vencido = this.tipo == '2'
            this.filtro.baixado = this.tipo == '3'
            this.filtro.perdido = this.tipo == '4'
            this.filtro.todosvencidos = this.tipo == '5'
            this.filtro.emitidosperiodo = this.tipo == '6'
            this.filtro.abertosdataalteracao = this.tipo == '7'
            this.filtro.dataalteracao = this.tipo == '9'

            if (this.pagarTab)
                this.filtro.tipo = 'PAGAR'
            else
            if (this.receberTab)
                this.filtro.tipo = 'RECEBER'
            else {
                this.handleLimparFiltros(true)
                this.filtro.tipo = 'EXTRATO'
           }
            if (!this.contas || this.contas.length == 0)
                this.filtro.contas = []
            else
                this.filtro.contas = this.contas

            this.filtro.codpart = this.codpart
            this.filtro.codcta = this.codcta
            this.filtro.vlr = this.valor
            this.filtro.doc = this.documento

            let url = "fin/list"

            if (excel){
              apiDownload2(this, url, this.filtro, "post")
            }else {
              apiORDSpost(this.$store, url, this.filtro, "post").then((data) => {
                  if (this.extratoTab) {
                      let temp = data
                      let saldoInicial = data.totais.saldoInicial

                      for (let i = 0; i < temp.dados.length; i++) {
                          if (temp.dados[i].tipo == 'R' || temp.dados[i].tipo == 'E')
                            saldoInicial = saldoInicial + temp.dados[i].vlr
                          else
                            saldoInicial = saldoInicial - temp.dados[i].vlr

                          temp.dados[i].saldo = saldoInicial
                      }

                      this.dados = temp
                  } else {
                      this.dados = data
                  }

                  this.$nextTick(function () {
                      jQuery('[data-toggle="tooltip"]').tooltip()
                  })

              })


            }
        },

        async getContas() {
            const params = null
            const modulo = 'select/cta/'
            const data = await apiORDS(this.$store.getters.urlOrds + modulo, params)
            if (data.items) {
                const contas = this.changeObjKey(data.items)
                this.listContas = contas
            }
        },
        // Muda a chave do objeto para que seja carregado corretamente no select2
        changeObjKey(arr) {
            return arr.map(entry => {
                return Object.keys(entry).reduce((obj, key) => {
                    const value = entry[key] // ler o valor
                    if (key === 'value') key = 'text' // mudar o nome da chave
                    obj[key] = value
                    return obj
                }, {})
            })
        },

        async loadFilial () {
            await this.$store.dispatch('loadFilial', { id: '1' } )
            if (this.$store.getters.getFilial) {
                this.filial = {...this.$store.getters.getFilial}
            }
        }

    },

    filters: {

    },

    components: {
        BarList,
        BarGrid,
        FilterList,
        FinanceiroForm,
        FinanceiroTransfForm,
        FinanceiroMovimentoForm,
        Button,
        FinanceiroPrintRecibo,
        FinanceiroRelatorioAgrupado,
        FinanceiroRelatorioData,
        FinanceiroRelatorioExtrato
    },

    mounted () {

        this.tipo = '1'
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())
        this.loadFilial()
        this.getContas()
        this.loadData()

    },

    created () {

    }

}

</script>

<template>

    <div>
        <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>
        <!-- Filtro -->
        <div class="row d-flex justify-content-between align-items-center mt-2 mb-2">
            <div class="col-md-4 col-12">
                <div style="margin-bottom: .3rem" class="d-flex align-items-center">
                  <v-label
                    class="m-0"
                    label="Período de:"
                  ></v-label>
                  <span class="ml-1">
                    {{ periodo.startDate | formatData }} até {{ periodo.endDate | formatData }}
                  </span>
                </div>
                <input-month :p-month="periodo" :show-options="true"></input-month>
            </div>

            <div class="col-md-3 col-12">
                <form-field
                  v-model="contas"
                  :select-options="listContas"
                  :selectMultiple="true"
                  label="Selecione as contas a exibir"
                  placeholder="Exibindo todas as contas"
                  type="select2static"
                ></form-field>
            </div>

            <!-- <form-field v-if="!extratoTab" v-model="tipos" type="select2static" col="6" label="Exibir"
                :select-options="listTipos" :selectMultiple="true" placeholder="Selecione o que deseja visualiar"></form-field> -->

            <div class="col-auto ml-auto d-flex">
                <v-button title="Atualizar Grid" icon="fa-refresh" @click="loadData"></v-button>
                <v-button v-if="extratoTab" icon="fa-plus" :nb-btdef="true" label="Novo Lançamento" @click="handleNew"></v-button>
                <v-button v-else icon="fa-plus" :nb-btdef="true" label="Nova Conta" @click="handleNew"></v-button>
                <v-button label="Mais Ações" :actions="maisAcoes" @click="handleNew"></v-button>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-12">
                <div class="border bg-light p-2" v-if="!extratoTab">
                    <div class="row px-2">
                        <form-field
                          v-model="tipo"
                          :optionnull="true"
                          :select-options="listFiltros"
                          col="4"
                          label="Tipo"
                          type="select"
                        ></form-field>

                        <form-field
                          v-model="codpart"
                          :select2="{entity: 'part', minlength: 2}"
                          col="4"
                          label="Cliente"
                          type="select2"
                        ></form-field>
                    </div>

                    <div class="row px-2">
                      <form-field
                        v-model="documento.value"
                        col="3"
                        label="Nr Documento"
                        type="text"
                      ></form-field>

                      <form-field
                        v-model="valor.start"
                        :precision="2"
                        col="3"
                        label="Valor De"
                        type="value"
                      ></form-field>

                      <form-field
                        v-model="valor.end"
                        :precision="2"
                        col="3"
                        label="Valor Até"
                        type="value"
                      ></form-field>
                    </div>

                    <div class="row px-4 py-2 mb-2">
                        <v-button label="Filtrar" :success="true" @click="loadData"></v-button>
                        <v-button label="Limpar Filtros" @click="handleLimparFiltros"></v-button>
                    </div>
                    <!--
                    <div><v-label label="Selecione os movimentos a exibir"></v-label> </div>
                    <div class="list-unstyled d-flex justify-content-around align-items-center mb-0 py-2">
                        <li>
                            <input type="checkbox" :value="'1'" id="abertas" v-model="tipos" />
                            <label for="abertas">A vencer no período</label>
                        </li>
                        <li>
                            <input type="checkbox" :value="'2'" id="vencidas" v-model="tipos" />
                            <label for="vencidas">Vencidos no período</label>
                        </li>
                        <li>
                            <input type="checkbox" :value="'5'" id="vencAnterior" v-model="tipos" />
                            <label for="vencAnterior">Todos vencidos</label>
                        </li>
                        <li>
                            <input type="checkbox" :value="'3'" id="baixadas" v-model="tipos" />
                            <label for="baixadas">Baixados</label>
                        </li>
                        <li>
                            <input type="checkbox" :value="'4'" id="perdidas" v-model="tipos" />
                            <label for="perdidas">Cancelados/Perdidos</label>
                        </li>
                        <li>
                            <input type="checkbox" :value="'6'" id="emitidas" v-model="tipos" />
                            <label for="emitidas">Todos Emitidos no período</label>
                        </li>
                    </div>
                    -->
                </div>
            </div>
        </div>

        <div class="row" v-if="this.dados && this.dados.totais">
            <div class="col-12">
                <!-- TOTAIS DO EXTRATO -->
                <div class="border bg-white mb-2" v-if="extratoTab">
                    <div class="row p-2 mr-2">
                        <div class="col-md-3 text-center" >
                            <span class="lbl-edit">
                                Saldo Inicial
                            </span>
                            <br>
                            <span class="total" :class="{ 'valor-negativo': this.dados.totais.saldoInicial < 0, 'valor-positivo': this.dados.totais.saldoInicial > 0}"> R$<strong> {{ this.dados.totais.saldoInicial | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Entradas </span><br>
                            <span class="total valor-positivo"> R$<strong> {{ this.dados.totais.totalRecebimentos | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Saídas </span><br>
                            <span class="total valor-negativo"> R$<strong> {{ this.dados.totais.totalPagamentos | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Saldo Final </span><br>
                            <span class="total"> R$<strong> {{ this.dados.totais.saldoFinal | formatValue(2,true) }} </strong></span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="w-100 text-center my-2">
                            <a v-if="extratoTab" style="cursor: pointer; color: #0091ea;"  data-toggle="collapse" data-target="#collapseSaldos" aria-expanded="false" aria-controls="collapseOrg">
                                <i class="fa fa-dollar" aria-hidden="true"></i>
                                Detalhar saldos iniciais
                            </a>
                        </div>
                    </div>
                    <div class="row collapse p-2 mr-2" id="collapseSaldos">
                        <div class="col-md-3 text-center mb-2" v-for="(conta, index) in this.dados.contas" :key="index">
                            <v-label :label="conta.conta"></v-label><br>
                            <span class="total"> R$<strong> {{ conta.saldo | formatValue(2,true) }} </strong></span>
                        </div>
                    </div>
                </div>

                <!-- TOTAIS DO CONTAS A PAGAR/RECEBER -->
                <div class="border bg-white mb-2" v-if="!extratoTab">
                    <div class="row p-2">
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> A Vencer </span><br>
                            <span class="total" v-if="receberTab"> R$<strong> {{ this.dados.totais.totalReceber | formatValue(2,true) }} </strong></span>
                            <span class="total" v-else> R$<strong> {{ this.dados.totais.totalPagar | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Vencidos </span><br>
                            <span class="total" v-if="receberTab"> R$<strong> {{ this.dados.totais.vencidosReceber | formatValue(2,true) }} </strong></span>
                            <span class="total" v-else> R$<strong> {{ this.dados.totais.vencidosPagar | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Baixados </span><br>
                            <span class="total valor-positivo" v-if="receberTab"> R$<strong> {{ this.dados.totais.totalRecebimentos | formatValue(2,true) }} </strong></span>
                            <span class="total valor-positivo" v-else> R$<strong> {{ this.dados.totais.totalPagamentos | formatValue(2,true) }} </strong></span>
                        </div>
                        <div class="col-md-3 text-center">
                            <span class="lbl-edit"> Perdidos ou Cancelados </span><br>
                            <span class="total valor-negativo"> R$<strong> {{ this.dados.totais.totalPerdidos | formatValue(2,true) }} </strong></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <filter-list v-if="!extratoTab" :params="paramFilterList" @select="handleFilterList"></filter-list> -->
        <div class="default-container">
            <div>
                <alert v-if="showAlert && finList.length == 0" type="warning" text="Nenhum título encontrado"></alert>
                <div v-if="finList.length > 0" class="row col fixed-top mx-auto menu-sticky py-2" style="background: white; width: 100%; max-width: 1078px;">
                    <div v-if="!extratoTab">
                        <a style="cursor: pointer; color: #0091ea;" @click="handleVerifyToCheckAll()"><i :class="'fa' + ' ' + (!allFinListChecked ? 'fa-check-square' : 'fa-minus')" aria-hidden="true"></i> <span class="ml-2"> {{!allFinListChecked ? 'Marcar' : 'Desmarcar' }} todos </span> </a>
                        <a class="ml-5" style="cursor: pointer; color: #0091ea;" @click="handlePrint(1)"><i class="fa fa-print" aria-hidden="true"></i> Imprimir Recibo </a>
                        <a v-if="receberTab" class="ml-5" style="cursor: pointer; color: #0091ea;" @click="handleEnviarEmail"><i class="fa fa-send" aria-hidden="true"></i> Enviar Boletos </a>
                        <a v-if="receberTab" class="ml-5" style="cursor: pointer; color: #0091ea;" @click="handleCobranca"><i class="fa fa-envelope" aria-hidden="true"></i> Enviar Carta de Cobrança </a>
                    </div>
                </div>

                <!-- Barra de Cabeçalho de Ordenação -->
                <div v-if="finList.length > 0" class="sorting-header-bar mt-2 mb-3 d-none d-md-block">
                    <!-- Para Contas a Receber e Pagar -->
                    <div v-if="!extratoTab" class="row align-items-center text-muted font-weight-bold">
                        <div class="col-auto ml-2" style="width: 38px; flex: 0 0 38px;">
                            <!-- Espaço para o checkbox de seleção em lote -->
                        </div>
                        <div class="col-auto clickable-header" style="width: 110px; flex: 0 0 110px; max-width: 110px;" @click="sortBy('doc')">
                            Doc. <i class="fa" :class="getSortIcon('doc')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 100px; flex: 0 0 100px; max-width: 100px;" @click="sortBy('dtemissao')">
                            Dt.Emi <i class="fa" :class="getSortIcon('dtemissao')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 100px; flex: 0 0 100px; max-width: 100px;" @click="sortBy('vencimento')">
                            Dt.Venc <i class="fa" :class="getSortIcon('vencimento')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 90px; flex: 0 0 90px; max-width: 90px;" @click="sortBy('natureza')">
                            Nat. <i class="fa" :class="getSortIcon('natureza')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 230px; flex: 0 0 230px; max-width: 230px;" @click="sortBy('nome')">
                            <span v-if="receberTab">Cliente</span>
                            <span v-else>Fornecedor</span>
                            <i class="fa" :class="getSortIcon('nome')"></i>
                        </div>
                        <div class="col-auto clickable-header text-right" style="width: 90px; flex: 0 0 90px; max-width: 90px;" @click="sortBy('vlr')">
                            Valor <i class="fa" :class="getSortIcon('vlr')"></i>
                        </div>
                        <div class="col-auto clickable-header text-center" style="width: 110px; flex: 0 0 110px; max-width: 110px;" @click="sortBy('dataBaixa')">
                            Pag/Canc. <i class="fa" :class="getSortIcon('dataBaixa')"></i>
                        </div>
                    </div>

                    <!-- Para Caixa e Bancos (Extrato) -->
                    <div v-if="extratoTab" class="row align-items-center text-muted font-weight-bold">
                        <div class="col-auto clickable-header" style="width: 130px; flex: 0 0 130px; max-width: 130px;" @click="sortBy('doc')">
                            Documento <i class="fa" :class="getSortIcon('doc')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 110px; flex: 0 0 110px; max-width: 110px;" @click="sortBy('data')">
                            Data <i class="fa" :class="getSortIcon('data')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 180px; flex: 0 0 180px; max-width: 180px;" @click="sortBy('natureza')">
                            Natureza <i class="fa" :class="getSortIcon('natureza')"></i>
                        </div>
                        <div class="col-auto clickable-header" style="width: 250px; flex: 0 0 250px; max-width: 250px;" @click="sortBy('nome')">
                            Cliente/Fornecedor <i class="fa" :class="getSortIcon('nome')"></i>
                        </div>
                        <div class="col-auto text-center" style="width: 80px; flex: 0 0 80px; max-width: 80px;">
                            <!-- Espaço para ícones e tipo de recebimento -->
                        </div>
                        <div class="col-auto clickable-header text-right" style="width: 100px; flex: 0 0 100px; max-width: 100px;" @click="sortBy('vlr')">
                            Valor <i class="fa" :class="getSortIcon('vlr')"></i>
                        </div>
                        <div class="col-auto clickable-header text-right" style="width: 110px; flex: 0 0 110px; max-width: 110px;" @click="sortBy('saldo')">
                            Saldo <i class="fa" :class="getSortIcon('saldo')"></i>
                        </div>
                    </div>
                </div>

                <!-- CONTAS A PAGAR E RECEBER -->
                <div class="mainbox" v-if="!extratoTab" v-for="(fin, index) in finList" :key="index">
                    <div :class="{ 'mark-green': fin.baixado, 'mark-red': fin.cancelado || fin.perdido }"></div>
                    <div class="box" :class="{ 'c-baixado': fin.baixado, 'c-perdido': fin.cancelado || fin.perdido }">
                        <div class="row align-items-center">
                            <div class="col-auto ml-2 pb-2" style="width: 38px; flex: 0 0 38px;">
                                <input-checkbox v-model="fin.isChecked" :value-checked="true" :value-unchecked="false"></input-checkbox>
                            </div>
                            <div class="col-auto" style="width: 110px; flex: 0 0 110px; max-width: 110px;">
                                <label class="lbl-list">Documento</label><br>
                                <span class="data-list-sm text-truncate">{{ fin.doc }} / {{ fin.parcela }} </span>
                                <i v-if="fin.recorrente" class="fa fa-recycle float-right" style="font-size: 20px; color: gray" data-toggle="tooltip" data-placement="top" title="Recorrente"></i>
                            </div>
                            <div class="col-auto" style="width: 100px; flex: 0 0 100px; max-width: 100px;">
                                <label class="lbl-list">Emissão</label><br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top" :data-original-title="datasTitulo(fin)">{{ fin.dtemissao | formatData }}</span>
                            </div>
                            <div class="col-auto" style="width: 100px; flex: 0 0 100px; max-width: 100px;">
                                <label class="lbl-list">Vencimento</label><br>
                                <span class="data-list-sm text-truncate">{{ fin.vencimento | formatData }}</span>
                            </div>
                            <div class="col-auto" style="width: 90px; flex: 0 0 90px; max-width: 90px;">
                                <label class="lbl-list">Natureza</label><br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top" :title="fin.natureza">{{ fin.natureza }}</span>
                            </div>
                            <div class="col-auto" style="width: 230px; flex: 0 0 230px; max-width: 230px;">
                                <label class="lbl-list" v-if="receberTab">Cliente</label>
                                <span class="lbl-list" v-else>Fornecedor</span>
                                <br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top" :title="getClienteLabel(fin)">{{ fin.nome }} {{ fin.descricao }}
                                    <span v-if="fin.npedido">Pedido {{ fin.npedido }}</span>
                                    <span v-if="fin.descricao">{{ fin.descricao }}</span>
                                    <span v-if="fin.texto">{{ fin.texto }}</span>
                                </span>
                            </div>
                            <div class="col-auto text-right" style="width: 90px; flex: 0 0 90px; max-width: 90px;">
                                <label class="lbl-list">Valor</label><br>
                                <span class="data-list-sm text-truncate">{{ fin.vlr | formatValue(2, true) }}</span>
                            </div>
                            <div class="col-auto text-center d-flex flex-column justify-content-center align-items-center" style="width: 110px; flex: 0 0 110px; max-width: 110px;">
                                <label class="lbl-list">Situação</label><br>
                                <div v-if="fin.aberto">
                                    <i v-if="fin.vencido" class="fa fa-circle" style="color: yellow; padding: .25rem" data-toggle="tooltip" data-placement="top" :title="'Dias de atraso: ' + fin.dias"></i>
                                    <!-- <i v-if="fin.vencido" class="fa fa-hourglass-o" color="silver" data-toggle="tooltip" data-placement="top" :title="'Dias de atraso: ' + fin.dias"></i> -->
                                    <i v-if="receberTab && fin.boleto" class="fa fa-envelope" style="color: silver; padding: .25rem" data-toggle="tooltip" data-placement="top" title="Boleto Enviado"></i>
                                    <i v-if="fin.stremessacnab == 1 || fin.stremessacnab == 2" class="fa fa-university" style="color: silver; padding: .25rem" data-toggle="tooltip" data-placement="top" title="Este título está em remessa e não pode ser alterado"></i>
                                    <span class="data-list-sm text-muted">Aberto</span>
                                </div>
                                <div v-else-if="fin.perdido || fin.cancelado || fin.baixado">
                                    <span class="badge" :class="[{'badge-red': fin.cancelado || fin.perdido}, {'badge-green': fin.baixado && !fin.parcial}, {'badge-yellow': fin.parcial}]" data-toggle="tooltip" data-placement="top" :title="fin.baixado ? 'Baixado em ' + dataStr(fin.dataBaixa) : (fin.dataBaixa ? 'Cancelado/Perdido em ' + dataStr(fin.dataBaixa) : '')">{{ textST(fin) }}</span>
                                </div>
                            </div>
                            <div class="col-auto ml-auto text-right">
                                <!-- <span class="badge mb-1" :class="[{'badge-green': fin.aberto=='S'},{'badge-silver': fin.baixado=='S'},{'badge-yellow': fin.perdido=='S'},{'badge-red': fin.cancelado=='S'}]" >{{ textST(fin) }}</span> -->
                                <div class="d-flex justify-content-center align-items-center">
                                    <img v-if="fin.banco_url" :src="fin.banco_url" alt="Logo do Banco" style="width: 38px; height: 38px; border-radius: 5px" class="m-2" data-toggle="tooltip" data-placement="top" :title="fin.banco_nome">
                                    <v-button title="Editar" icon="fa-pencil" @click="handleEdit(fin)"></v-button>
                                    <v-button v-if="(fin.aberto && fin.emiteboleto) && receberTab" title="Emitir Boleto" icon="fa-barcode" @click="handleEmiteBoleto(fin)"></v-button>
                                    <!-- <v-button v-if="fin.aberto" title="Cancelar" :danger="true" icon="fa-trash" @click="handleShowCancela(fin)"></v-button> -->
                                    <v-button v-if="fin.aberto && receberTab" title="Baixar como recebido" :success="true" icon="fa-check" @click="handleBaixar(fin.codfin)"></v-button>
                                    <v-button v-if="fin.aberto && pagarTab" title="Baixar como pago" :success="true" icon="fa-check" @click="handleBaixar(fin.codfin)"></v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- EXTRATO -->
                <div class="mainbox" v-if="extratoTab" v-for="(fin, index) in finList" :key="index">
                    <!-- <div class="mark-gray"></div> -->
                    <div class="box">
                        <div class="row align-items-center">
                            <!-- <div class="col-auto ml-2">
                                <input-checkbox v-model="fin.isChecked" :value-checked="true" :value-unchecked="false"></input-checkbox>
                            </div> -->
                            <div class="col-auto" style="width: 130px; flex: 0 0 130px; max-width: 130px;">
                                <label class="lbl-list">Documento</label><br>
                                <span class="data-list-sm text-truncate">{{ fin.doc }} / {{ fin.parcela }}</span>
                            </div>
                            <div class="col-auto" style="width: 110px; flex: 0 0 110px; max-width: 110px;">
                                <label class="lbl-list">Data</label><br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top">{{ fin.data | formatData }}</span>
                            </div>
                            <div class="col-auto" style="width: 180px; flex: 0 0 180px; max-width: 180px;">
                                <label class="lbl-list">Natureza</label><br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top" :title="fin.natureza">{{ fin.natureza }}</span>
                            </div>
                            <div class="col-auto" style="width: 250px; flex: 0 0 250px; max-width: 250px;">
                                <label class="lbl-list">Cliente/Fornecedor</label>
                                <br>
                                <span class="data-list-sm text-truncate" data-toggle="tooltip" data-placement="top" :title="getClienteLabel(fin)">{{ fin.nome }}
                                    <span class="data-list-sm" v-if="fin.npedido">Pedido {{ fin.npedido }}</span>
                                    <span class="data-list-sm" v-if="fin.descricao">{{ fin.descricao }}</span>
                                    <span class="data-list-sm" v-if="fin.texto">{{ fin.texto }}</span>
                                </span>
                            </div>
                            <div class="col-auto text-center d-flex justify-content-center align-items-center" style="width: 80px; flex: 0 0 80px; max-width: 80px;">
                                <div v-if="fin.parcial" class="fa fa-adjust mr-1" style="color: lime" data-toggle="tooltip" data-placement="top" title="Baixa parcial"></div>
                                <span v-if="fin.tipo == 'R' || fin.tipo == 'E'" class="tipo tipo-recebimento" data-toggle="tooltip" data-placement="top" title="Recebimento"> {{ fin.tipo }} </span>
                                <span v-if="fin.tipo == 'P' || fin.tipo == 'S'" class="tipo tipo-pagamento" data-toggle="tooltip" data-placement="top" title="Pagamento"> {{ fin.tipo }} </span>
                            </div>
                            <div class="col-auto text-right" style="width: 100px; flex: 0 0 100px; max-width: 100px;">
                                <label class="lbl-list">Valor</label><br>
                                <span class="data-list-sm text-truncate" :class="{ 'valor-negativo': fin.tipo == 'P', 'valor-positivo': fin.tipo == 'R'}">{{ fin.vlr | formatValue(2, true) }}</span>
                            </div>
                            <div class="col-auto text-right" style="width: 110px; flex: 0 0 110px; max-width: 110px;">
                                <label class="lbl-list">Saldo</label><br>
                                <span class="data-list-sm text-truncate" :class="{ 'valor-negativo': fin.saldo < 0, 'valor-positivo': fin.tipo >= 0}"><strong>{{ fin.saldo | formatValue(2, true) }}</strong></span>
                            </div>
                            <div class="col-auto ml-auto text-right">
                                <div class="d-flex justify-content-center align-items-center">
                                    <v-button title="Editar" icon="fa-pencil" @click="handleEdit(fin)"></v-button>
                                    <!-- <v-button v-if="fin.aberto" title="Baixar como recebido" icon="fa-check" @click="handleBaixar(fin.codfin)"></v-button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <financeiro-form v-if="showForm" :index="this.codfin" :tipo="tipofin" :crud="this.crud" @closeform="closeForm"></financeiro-form>
        </transition>

        <transition name="fade">
            <financeiro-transf-form v-if="showTransfForm" :crud="this.crud" @closeform="closeForm"></financeiro-transf-form>
        </transition>

        <transition name="fade">
            <financeiro-movimento-form v-if="showMovForm" :index="this.codfin" :crud="this.crud" @closeform="closeForm"></financeiro-movimento-form>
        </transition>

        <!-- Impressão de Recibo -->
        <div id="recibo" v-show="false">
            <financeiro-print-recibo
                 v-if="showRecibo"
                :fin-list="printFinList"
                :receber-tab="receberTab"
                :pagar-tab="pagarTab"
                :filial="filial"
                @close="handleClosePrint"
            />
        </div>

        <!-- Impressão de Relatório -->
        <div id="relatorio" class="mt-5" v-show="false">
            <financeiro-relatorio-agrupado
                v-if="showRelatorio"
                :fin-list-grupo="finListGrupo"
                :receber-tab="receberTab"
                :pagar-tab="pagarTab"
                :periodo-recebimento="periodoRecebimento"
                :periodo-vencimento="periodoVencimento"
                :periodo-emissao="periodoEmissao"
                :periodo="periodo"
                :documento="documento"
                :codpart="codpart"
                :valor="valor"
                :companyName="companyName"
                 @close="handleClosePrint"
            />
        </div>

        <!-- Impressão de Relatório (Data) -->
        <div id="relatorio-data" class="mt-5" v-show="false">
            <financeiro-relatorio-data
                v-if="showRelatorioData"
                :finListGrupo="finListGrupo"
                :fin-list-grupo-data="finListGrupoData"
                :receber-tab="receberTab"
                :pagar-tab="pagarTab"
                :periodo-recebimento="periodoRecebimento"
                :periodo-vencimento="periodoVencimento"
                :periodo-emissao="periodoEmissao"
                :periodo="periodo"
                :documento="documento"
                :codpart="codpart"
                :valor="valor"
                :companyName="companyName"
                @close="handleClosePrint"
            />
        </div>

        <!-- Impressão Relatório Extrato -->
        <div id="relatorio-extrato" class="mt-5" v-show="false">
            <financeiro-relatorio-extrato
                v-if="showRelatorioExtrato"
                :periodo="periodo"
                :dados="dados"
                :fin-list="finList"
                :companyName="companyName"
                @close="handleClosePrint"
            />
        </div>

        <!-- Modal Carta de Cobrança -->
        <div class="nb-modal-scrollable" v-if="showModalCobranca">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Envio de e-mail de Carta de Cobrança</h5>
                    <button type="button" class="close" @click="closeModalCobranca" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="ml-3 mb-3">
                        <input-checkbox v-model="cartaCobrancaCheckAll" :value-checked="true" :value-unchecked="false" label="Marcar todos"></input-checkbox>
                    </div>
                    <!-- TÍTULOS VENCIDOS DE CONTAS A RECEBER -->
                    <div class="mainbox">
                        <div class="row align-items-center px-3">
                            <div class="col-md-5 d-flex align-items-center">
                                <div class="d-flex flex-column">
                                    <label class="lbl-list">Nome do Cliente</label>
                                </div>
                            </div>

                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Valor</label>
                            </div>

                            <div class="col-md-4 text-left">
                                <label class="lbl-list">Email</label>
                            </div>
                        </div>
                    </div>
                    <div class="mainbox" v-for="(cliente, index) in titulosVencidosPorCliente" :key="index">
                        <div class="row align-items-center px-3">
                            <div class="col-md-5 col-6 d-flex justify-content-start align-items-center">
                                <div class="mt-n4">
                                    <input-checkbox v-model="cliente.isChecked" :value-checked="true" :value-unchecked="false"></input-checkbox>
                                </div>
                                <div>
                                    <span class="data-list-sm">{{ cliente.nome }}</span>
                                </div>
                            </div>

                            <div class="col-md-2 col-6 text-left">
                                <span class="data-list-sm">{{ cliente.total | formatValue(2, true) }}</span>
                            </div>

                            <div class="col-md-4 text-left">
                                <form-field v-model="cliente.email" type="text"></form-field>
                            </div>
                        </div>
                    </div>
                    <div class="nb-modal-scrollable-footer mt-3">
                        <v-button ref="btnConfirm" label="Enviar" title="" @click="handleEnviarCobranca"></v-button>
                        <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalCobranca"></v-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="nb-modal-scrollable" v-if="showModalErrosBoleto">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Erro ao enviar emails de boletos</h5>
                    <button type="button" class="close" @click="closeModalErros" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="mainbox">
                        <div class="row align-items-center px-3">
                            <div class="col-md-1 text-left">
                                <label class="lbl-list">Nr Doc</label>
                            </div>

                            <div class="col-md-2 d-flex align-items-center">
                                <div class="d-flex flex-column">
                                    <label class="lbl-list">Nome do Cliente</label>
                                </div>
                            </div>

                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Email</label>
                            </div>

                            <div class="col-md-1 text-left">
                                <label class="lbl-list">Valor</label>
                            </div>

                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Vencimento</label>
                            </div>

                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Erro</label>
                            </div>
                        </div>
                    </div>
                    <div class="mainbox" v-for="(erro, index) in listErrosBoleto" :key="index">
                        <div class="row align-items-center px-3">
                            <div class="col-md-1 col-6 text-left">
                                <span class="data-list-sm">{{ erro.doc }}</span>
                            </div>

                            <div class="col-md-2 col-6 d-flex justify-content-start align-items-center">
                                <!-- <div class="mt-n4">
                                    <input-checkbox v-model="cliente.isChecked" :value-checked="true" :value-unchecked="false"></input-checkbox>
                                </div> -->
                                <div>
                                    <span class="data-list-sm">{{ erro.nome }}</span>
                                </div>
                            </div>

                            <div class="col-md-2 text-left">
                                <!-- <form-field v-model="erro.email" type="text"></form-field> -->
                                <span class="data-list-sm">{{ erro.email }}</span>
                            </div>

                            <div class="col-md-1 col-6 text-left">
                                <span class="data-list-sm">{{ erro.vlr | formatValue(2, true) }}</span>
                            </div>

                            <div class="col-md-2 col-6 text-left">
                                <span class="data-list-sm">{{ erro.dtv | formatData }}</span>
                            </div>

                            <div class="col-md-4 col-6 text-left">
                                <span class="data-list-sm" style="white-space: pre-line">{{ erro.erros[0] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="nb-modal-scrollable-footer mt-3">
                        <v-button ref="btnClose" label="Fechar" title="" @click="closeModalErros"></v-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Enviar E-mail Boleto -->
        <div class="nb-modal-scrollable" v-if="showModalEnviarEmailBoleto">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-header">
                    <h5>Envio de Boleto por E-mail</h5>
                    <button type="button" class="close" @click="closeModalEnviarEmailBoleto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="nb-modal-scrollable-body">
                    <div class="mainbox">
                        <div class="row align-items-center px-3">
                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Documento</label>
                            </div>
                            <div class="col-md-4 d-flex align-items-center">
                                <div class="d-flex flex-column">
                                    <label class="lbl-list">Nome do Cliente</label>
                                </div>
                            </div>
                            <div class="col-md-2 text-left">
                                <label class="lbl-list">Valor</label>
                            </div>
                            <div class="col-md-4 text-left">
                                <label class="lbl-list">Email Destinatário</label>
                            </div>
                        </div>
                    </div>
                    <div class="mainbox" v-for="(titulo, index) in selectedTitulosBoleto" :key="index">
                        <div class="row align-items-center px-3">
                            <div class="col-md-2 text-left">
                                <span class="data-list-sm">{{ titulo.doc }} / {{ titulo.parcela }}</span>
                            </div>
                            <div class="col-md-4 d-flex justify-content-start align-items-center">
                                <span class="data-list-sm">{{ titulo.nome }}</span>
                            </div>
                            <div class="col-md-2 text-left">
                                <span class="data-list-sm">R$ {{ titulo.vlr | formatValue(2, true) }}</span>
                            </div>
                            <div class="col-md-4 text-left">
                                <form-field v-model="titulo.email" type="text"></form-field>
                            </div>
                        </div>
                    </div>
                    <div class="nb-modal-scrollable-footer mt-3">
                        <v-button ref="btnConfirm" label="Enviar Boletos" title="" @click="handleConfirmarEnviarEmailBoleto"></v-button>
                        <v-button ref="btnClose" label="Cancelar" title="" @click="closeModalEnviarEmailBoleto"></v-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- TEMPLATE DO EMAIL DE COBRANCA -->
        <!-- <div class="template-email mt-5">
            <div>
                <p>Boa tarde, "Nome Fulano"! Segue os títulos vencidos que estão pendentes de pagamento.</p>
                <table width="500px" border="1px" cellpadding="7px">
                    <thead>
                        <tr>
                            <td style="text-align: center; vertical-align: middle;" height="30">Emissão</td>
                            <td style="text-align: center; vertical-align: middle;">Vencimento</td>
                            <td style="text-align: center; vertical-align: middle;">Documento</td>
                            <td style="text-align: center; vertical-align: middle;">Valor</td>
                            <td style="text-align: center; vertical-align: middle;">Dias de Atraso</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="text-align: center; vertical-align: middle;" height="30">#DATA#</td>
                            <td style="text-align: center; vertical-align: middle;">#DTV#</td>
                            <td style="text-align: center; vertical-align: middle;">#DOC#</td>
                            <td style="text-align: center; vertical-align: middle;">#VLR#</td>
                            <td style="text-align: center; vertical-align: middle;">#DIAS#</td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top: 16px">
                    <p>Atenciosamente,</p>
                    <p>#FILIAL#</p>
                </div>
            </div>
        </div> -->
    </div>
</template>


<style scoped>
.menu-sticky{
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    padding: 5px;
    z-index: 1;
}
.gap-10{
    gap: 10px;
}
.span-title {
    font-size: 1.1rem;
}

.span-header {
    font-size: 1rem !important;
    font-weight: 700 !important;
}

.uppercase {
    text-transform: uppercase;
}

th, td {
    font-size: .75rem !important;
    font-weight: 500 !important;
}

hr {
    color: transparent;
    border: none;
}


.half-payment {
    width: 20px;
    height: 10px;
    background-color: gold;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 1px solid gold;
    border-bottom: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

.c-baixado {
    background-color: #e9f5dc;
}

.c-perdido {
    background-color: #fdf7f3;
}

.tipo {
    display: inline-block;
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 20%;
}

.tipo-recebimento {
    color: #fff;
    background-color: #80b852;
}

.tipo-pagamento {
    color: #fff;
    background-color: #ee2727;
}

.valor-positivo {
    color: #80b852;
}

.valor-negativo {
    color: #ee2727;
}

.total strong {
    font-size: 20px;
    font-weight: 700;
}

.box-filtros {
    padding-left: .25rem !important;
}

.sorting-header-bar {
    background-color: #fcfcfc;
    border-radius: 6px;
    padding: 10px 15px;
    border: 1px solid #eaeaea;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.clickable-header {
    cursor: pointer;
    user-select: none;
    transition: color 0.15s ease-in-out;
    font-size: 0.78rem;
}

.clickable-header:hover {
    color: #0091ea !important;
}

.text-muted-light {
    color: #d1d5db !important;
    font-size: 0.7rem;
    margin-left: 3px;
}

</style>






// WEBPACK FOOTER //
// src/forms/financeiro-list.vue